const theme = {
  layout: {
    fontFamily: '\'Lato\', sans-serif',
    padding: '0 0.25rem',
    formControlSpacingHorizontal: '.5rem',
    formControlSpacingVertical: '1rem',
  },
  formLabel: {
    color: 'inherit',
    fontFamily: '\'Lato\', sans-serif',
    fontWeight: 700,
    fontSize: '1rem',
    margin: '0 0 .5rem 0'
  },
  formControl: {
    backgroundColor: '#fff',
    backgroundColorHover: '',
    borderColor: '#dee2e6',
    borderColorHover: '',
    borderColorFocus: '#86b7fe',
    borderColorError: '#dc3545',
    borderWidth: '1px',
    borderBottomWidth: '',
    borderLeftWidth: '',
    borderRightWidth: '',
    borderTopWidth: '',
    borderRadius: '.375rem',
    borderStyle: 'solid',
    boxShadow: '',
    boxShadowError: '',
    boxShadowErrorFocus: '0 0 0 .25rem rgba(220,53,69,.25)',
    boxShadowFocus: '0 0 0 .25rem rgba(13,110,253,.25)',
    color: '#212529',
    colorFocus: '',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5',
    margin: '0 0 0.25rem 0',
    padding: '.375rem .75rem',
  },
  errorMessage: {
    color: '#b02a37',
    margin: '.25rem 0 0 0',
    fontSize: '.875rem'
  }
};

export default theme;
